import React, { useState, useContext, Fragment, lazy, Suspense } from "react";
import { useHistory } from "react-router-dom";
import { Menu, MenuList, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react-lite";
import { playerStoreContext } from "lib/player_store";

const JangoLogoSVG = lazy(() =>
  import(
    /*webpackChunkName: "jnglgsvg" */ "svg/JangoLogoCurrentColor_320x121.svg"
  )
);

const useStyles = makeStyles((_theme) => ({
  paper: {
    backgroundColor: "#152f50",
    "& li": {
      color: "#fff",
      "&:hover": {
        background: "rgba(255, 255, 255, 0.1)",
      },
    },
  },
}));

const SiteMenu = observer(() => {
  const store = useContext(playerStoreContext);
  const { user_id } = store;
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState();

  const handleClick = (value) => (e) => {
    console.log("site menu VALUE", value, e);
    if (value === null) {
      return;
    }
    // if (value === "tour") {
    //   onTour();
    // } else {
    //  history.push(value)
    nav(value);
    //}
    e?.preventDefault();
    e?.stopPropagation();
    setClose();

    return false;
  };

  const nav = (value) => {
    history.push(value)
    //return Turbolinks.visit(value);
  };

  const setClose = () => {
    setAnchorEl(null);
    //  this.setState({ open: false });
  };

  const setOpen = (e) => {
    setAnchorEl(e.currentTarget);
    // this.setState({ open: true, anchorEl: e.currentTarget });
  };

  let menu_items = [];
  if (user_id > 0) {
    menu_items = menu_items.concat([
      {
        key: "browse_music",
        text: "Browse Music",
        value: "/browse_music/genre/Recommended",
      },
      {
        key: "band_central",
        text: "Band Central",
        value: "/band_central/discover",
      },
      {
        key: "song_fav",
        text: "Favorite Songs",
        value: "/song_ratings/favorites",
      },
      {
        key: "station_history",
        text: "Station History",
        value: `/users/${user_id}/stations`,
      },
      {
        key: "song_history",
        text: "Song History",
        value: `/users/${user_id}/stations`,
      },

      {
        key: "song_search",
        text: "Find Songs",
        value: "/songs/search",
      },
      {
        key: "artist_search",
        text: "Find Artists",
        value: "/artists/search",
      },
      {
        key: "song_ban",
        text: "Banned Songs",
        value: "/song_ratings/bans",
      },
      // {
      //   key: "tour",
      //   text: "Site Tour",
      //   value: "tour",
      // },
    ]);
  } else {
    menu_items = menu_items.concat([
      {
        key: "browse_music",
        text: "Browse Music",
        value: "/browse_music/genre/Top Stations",
      },
      {
        key: "band_central",
        text: "Band Central",
        value: "/band_central/discover",
      },
      {
        key: "song_fav",
        text: "Favorite Songs",
        value: "/song_ratings/favorites",
      },
      {
        key: "station_history",
        text: "Station History",
        value: "/users/0/stations",
      },
      {
        key: "song_history",
        text: "Song History",
        value: "/users/0/stations",
      },

      {
        key: "song_search",
        text: "Find Songs",
        value: "/songs/search",
      },
      {
        key: "artist_search",
        text: "Find Artists",
        value: "/artists/search",
      },
      {
        key: "song_ban",
        text: "Banned Songs",
        value: "/song_ratings/bans",
      },
      // {
      //   key: "tour",
      //   text: "Site Tour",
      //   value: "tour",
      // },
    ]);
  }

  //const { value, open, anchorEl } = this.state;

  const classes = useStyles();

  return (
    <Fragment>
      <Suspense fallback={null}>
        <JangoLogoSVG id="main-logo" onClick={setOpen} />
      </Suspense>
      <Menu
        disableScrollLock={true}
        classes={{ paper: classes.paper }}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={setClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MenuList>
          {menu_items.map((h) => {
            return (
              <MenuItem
                key={h.key}
                value={h.value}
                onClick={handleClick(h.value)}
              >
                {h.text}
              </MenuItem>
            );
          })}
        </MenuList>
      </Menu>
    </Fragment>
  );
});

export default SiteMenu;
